import React, {Component} from "react";
import { Timeline } from 'react-twitter-widgets'

import "../App.css";


class Twitter extends Component {
    style = {
        margin: 20,
        fontFamily: 'monospace',
        padding: 12
    };

    render() {
        return (
            <Timeline
                dataSource={{
                    sourceType: 'profile',
                    screenName: 'headfirstdroid'
                }}
                options={{
                    username: 'HeadFirstDroid'
                }}
                onLoad={() => console.log('Timeline is loaded!')}
            />
        );
    }
}

export default Twitter;



// WEBPACK FOOTER //
// ./src/containers/Twitter.js